/**
 * @generated SignedSource<<6276397033bb5be2668ebd9e7d7c1b8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDutiesMessage_shipmentQuote$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDutiesMessage_shipmentQuote";
};
export type PdpSharedDutiesMessage_shipmentQuote$key = {
  readonly " $data"?: PdpSharedDutiesMessage_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDutiesMessage_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "668b9634d3ee827a5c078ed31a4a1cee";

export default node;
